module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./client/app/pma-category/pma-category.component.scss
// module id = ./client/app/pma-category/pma-category.component.scss
// module chunks = main